import { render, staticRenderFns } from "./CategorySales.vue?vue&type=template&id=6958eedf&scoped=true&"
import script from "./CategorySales.vue?vue&type=script&lang=js&"
export * from "./CategorySales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6958eedf",
  null
  
)

export default component.exports